import IndexTable from '@lib/components/index-table/IndexTable'
import AuditTableRow from './AuditTableRow'

export default class AuditTable extends IndexTable {
    rowComponentClass = AuditTableRow

    static defaultProps = {
        features: [],
        keyName: 'id'
    }
}
